export const SELECT_CHAT_MEMBER_INITIATING = 'SELECT_CHAT_MEMBER_INITIATING'
export const SELECT_CHAT_MEMBER_INITIATED = 'SELECT_CHAT_MEMBER_INITIATED'
export const SELECT_CHAT_MEMBER_RESET = 'SELECT_CHAT_MEMBER_RESET'
export const SELECT_CHAT_MEMBER_LOADING = 'SELECT_CHAT_MEMBER_LOADING'
export const SELECT_CHAT_MEMBER_LOADED = 'SELECT_CHAT_MEMBER_LOADED'
export const SELECT_CHAT_MEMBER_SET_VALUE = 'SELECT_CHAT_MEMBER_SET_VALUE'
export const SELECT_CHAT_MEMBER_SHOW_MENU_LOADER = 'SELECT_CHAT_MEMBER_SHOW_MENU_LOADER'
export const SELECT_CHAT_MEMBER_ERROR = 'SELECT_CHAT_MEMBER_ERROR'
export const ADD_MEMBER_TO_CHAT = 'ADD_MEMBER_TO_CHAT'
